<template>
  <div class="mine page">
    <div class="page-bg" ></div>
    <div class="wrapper">
 
<van-pull-refresh
  v-model="isLoading"
  @refresh="onRefresh"
  :pulling-text="$t('reservation.pull')"
  :loosing-text="$t('reservation.release')"
  :loading-text="$t('reservation.loading')"
>

         <div class="header">
           <van-nav-bar class="nav-bar">
             <template #right>
               <!-- <van-icon name="setting-o" @click="showSetting()" color="#fff"/> -->
               <van-icon name="chat-o" @click="openService()" color="#fff"/>
             </template>
           </van-nav-bar>
           <div class="user-wrapper" @click="doLogin()">
             <!-- <van-image round class="user_img" src="http://kongh5.haiwaiym18.top/img/avatar.b93a1df3.png">
               <template v-slot:loading>
                 <van-loading type="spinner"/>
               </template>
             </van-image> -->
             <van-image round class="user_img" :src="mineAvatarSrc" @error="onMineAvatarError">
               <template v-slot:loading>
                 <van-loading type="spinner"/>
               </template>
               <template v-slot:error>
                 <img :src="defaultAvatar" class="user_img_inner">
               </template>
             </van-image>
             <div class="login-content">
               <p class="login-btn" >{{this.userInfo.username}}</p>
             </div>
           </div>
         </div>
         <div class="content">
            <div class="finance">
              <!-- @click="toService()" -->
            <div class="finance-item"  @click="doWithdrawal()">
              <van-image class="icon-img" src="/img/mine/mingxi.svg" />
              <span class="text">{{$t("withdraw.immediately_withdraw")}}</span>
            </div>

            <!-- <div class="finance-item"  @click="doWithdrawal()">
              <van-icon class="icon" name="idcard" />
              <span class="text">{{$t("my.withdraw")}}</span>
            </div> -->
          </div>

            <div  class="wallet">
                <div class="part-1 van-hairline--bottom">
                  <p class="flex-1 font-28 font-primary-color">{{$t("my.activity_points")}}</p>

                </div>
                <div class="part-2">
                  <p class="balance van-ellipsis"></p>
                  <!-- <span class="font-28 font-gray">{{$t("my.balance")}}({{$t("reservation.unit")}})</span> -->
                  <span class="font-28 font-gray">{{$t("reservation.unit")}}</span>
                  <div class="refresh-btn" @click="refresh()"><van-icon name="replay" /></div>
                </div>
                <div class="part-2 part-3">
                  <p class="balance van-ellipsis">{{ this.userInfo.money }}</p>
                  <!-- <span class="font-28 font-gray">{{$t("my.balance")}}({{$t("reservation.unit")}})</span> -->

                </div>
            </div>

            <div :style="{ marginTop: menu_top +'px'}" class="menu" >
              <div class="menu-item" @click="$router.push({path:'/Infomation'});">
                <van-image class="menu-item-icon" src="/img/mine/nav1.png">
                  <template v-slot:loading>
                    <van-loading type="spinner"/>
                  </template>
                </van-image>
                <span class="menu-item-label" >{{$t("my.basic_information")}}</span>
              </div>
              <div class="menu-item" @click="$router.push({path:'/SetLoginPassword'});">
                <van-image class="menu-item-icon" src="/img/mine/nav7.png">
                  <template v-slot:loading>
                    <van-loading type="spinner"/>
                  </template>
                </van-image>
                <span class="menu-item-label" >{{$t("my.Login_password")}}</span>
                <!-- <span class="menu-item-label" >{{$t("my.account_detail")}}</span> -->
              </div>
              <div class="menu-item" @click="$router.push({path:'/GameRecord'});">
                <van-image class="menu-item-icon" src="/img/mine/baobiao.png">
                  <template v-slot:loading>
                    <van-loading type="spinner"/>
                  </template>
                </van-image>
                <span class="menu-item-label" >{{$t("my.task_log")}}</span>
              </div>
              <div class="menu-item"  @click="toNotice()">
                <van-image class="menu-item-icon" src="/img/mine/4.png">
                  <template v-slot:loading>
                    <van-loading type="spinner"/>
                  </template>
                </van-image>
                <span class="menu-item-label" >{{$t("my.sys_notice")}}</span>
              </div>
              <div class="menu-item" @click="openService()">
                <van-image class="menu-item-icon" src="/img/mine/5.png">
                  <template v-slot:loading>
                    <van-loading type="spinner"/>
                  </template>
                </van-image>
                <span class="menu-item-label" >{{$t("my.online_customer_service")}}</span>
              </div>

<div class="menu-item" @click="$router.push({path:'/Feedback'})">
  
  <van-image class="menu-item-icon" src="/img/mine/feedback.png">
    <template v-slot:loading>
      <van-loading type="spinner"/>
    </template>
  </van-image>
  <span class="menu-item-label">{{$t("my.date_share")}}</span>
</div>

              <!-- <div class="menu-item" @click="toService()">
                <van-image class="menu-item-icon" src="img/mine/kefu_1.svg">
                  <template v-slot:loading>
                    <van-loading type="spinner"/>
                  </template>
                </van-image>
                <span class="menu-item-label" >{{$t("my.online_service")}}</span>
              </div> -->
            </div>
            <div class="btn">
              <van-button color="linear-gradient(90deg,#6529c9,#cc2996)"  style="margin: 20px 0;font-size: 16px;padding:25px 0;width: 100%;border-radius: 14px;" @click="loginout()" >
                {{$t("setting.logout")}}
              </van-button>
            </div>
         </div>
      </van-pull-refresh>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      userInfo:{
      },
      menu_top:40,
      isLoading: false,
      defaultAvatar: '/img/avatar/avatar.png'
    };
  },
  computed: {
    mineAvatarSrc() {
      if (!this.userInfo || !this.userInfo.header_img) {
        return this.defaultAvatar;
      }
      return this.userInfo.header_img;
    }
  },
  methods: {
    // 同步调用全局客服挂件
    openService() {
      if (window.$chatwoot) {
        window.$chatwoot.toggle();
      }
    },
    onMineAvatarError() {
      this.userInfo.header_img = this.defaultAvatar;
    },
    refresh(){
      this.isLoading = true;
      this.refreshUserInfo();
    },
    exit(){
      this.$toast(this.$t("my.finish_task"));
    },
    showSetting() {
      if(localStorage.getItem('token')){
        this.$router.push({path:'/Setting'})
      }else{
        this.$router.push({path:'/Login'})
      }
    },
    toNotice(){
      if(localStorage.getItem('token')){
        this.$router.push({path:'/Notice'})
      }else{
        this.$router.push({path:'/Login'})
      }
    },
    onRefresh() {
      this.refreshUserInfo();
    },
    refreshUserInfo() {
      setTimeout(() => {
        this.isLoading = false;
        if(localStorage.getItem('token')){
            this.getUserInfo();
            this.$toast(this.$t("reservation.refresh"));
        }else{
            this.$router.push({path:'/Login'})
        }
      }, 500);
    },
    doLogin(){
        if(localStorage.getItem('token')){
            this.$router.push({path:'/Infomation'});
        }else {
            this.$router.push({path:'/Login'})
        }
    },
    doPay(){
      this.$router.push({
        name:'Recharge',
        params:{
          'balance':this.userInfo.money
        }
      })
    },
    doWithdrawal(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
          if(res.data.is_bank){
            this.$router.push("withdraw");
          }else {
            this.$router.push("Setbank");
            this.$toast.fail(this.$t("setting.set_bank"));
          }
      })
    },
    toService() {
      console.log(this.$store.getters.getBaseInfo)
      if(this.$store.getters.getBaseInfo.iskefu == 1){
        this.$router.push("Withdraw");
      }else {
        this.$toast.fail(this.$t("setting.forbid"));
      }
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data || {};
          if(!this.userInfo.header_img){
            this.userInfo.header_img = this.defaultAvatar;
          }
          console.log(this.userInfo);
          this.menu_top = 15;
          if(this.userInfo.status !== 1){
            this.$toast(this.$t("video.account_out"));
            localStorage.clear()
            this.$router.push({path:'/Login'})
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    loginout() {
      localStorage.clear()
      this.$router.push({path:'/Login'});
    }
  },
  created() {
    if(localStorage.getItem('token')){
        this.getUserInfo();
    }else {
      this.userInfo.username = this.$t("setting.log_reg");
      this.userInfo.ip = this.$t("setting.more_service");
      this.userInfo.header_img = this.defaultAvatar;
    }
  }
};
</script>

<style scoped>
.page{
  position: absolute!important;
  top: 0;
  left: 0;
  right: 0;
  background-color: #f2f2f5;
}
.mine{
  position: relative;
    bottom: 20px;
    background: #f2f2f5;
    background: url('/img/usertop.660cec17.png') no-repeat top -16vw center;
    background-size: contain;
    padding-bottom: 7vw;
}
.mine .wrapper{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.nav-bar{
  /* background: linear-gradient(
      90deg,#7e5678,#e6c3a1); */
      background: content-box;
}
.mine .header{
  padding-bottom: 100px;
  background-size: contain
}
::v-deep .van-nav-bar__content {
  height: 100px;
}
::v-deep .van-hairline--bottom::after {
  border-bottom-width: 0px;
}
.mine .header .van-nav-bar .van-icon {
  font-size: 45px;
}
.mine .header .user-wrapper{
  display: flex;
  align-items: center;
  margin: 0px 40px 0px 40px;
}
.mine .user_img{
  height: 130px;
  width: 130px;
}
.mine .user_img_inner{
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display: block;
}
::v-deep .van-loading__spinner {
  height: 50px;
  width: 50px;
}
::v-deep .van-image__error-icon {
  font-size: 70px;
}
.mine  .header .user-wrapper .login-content{
  flex: 1;
  margin-left: 30px;
}
.mine  .header .user-wrapper .login-content .login-btn{
  display: inline-block;
  font-size: 40px;
  line-height: 0px;
  color: #fff;
}
.mine .header .user-wrapper .login-content .login-label{
  margin-top: -13px;
  font-size: 28px;
  color: hsla(0,0%,100%,.6);
}
.mine .page-bg{
  height: 500px;
}
.mine .content{
  position: relative;
  padding: 10px 30px 30px;
  min-height: 500px;
  background-color: #f2f2f5;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #ffffff;
  font-size: 35px;
}

.mine .wrapper .content .finance {
  position: absolute;
  display: flex;
  align-items: center;
  top: -55px;
  left: 30px;
  right: 30px;
  height: 120px;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 0 1.5px 1px 0 #e4e4e7;
}
.mine .wrapper .content .finance .line{
  width: 3px;
  height: 40px;
  background-color: #ccc;
}
.mine .wrapper .content .finance .finance-item{
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.mine .wrapper .content .finance .finance-item .text{
  margin-left: 30px;
  font-size: 30px;
  color: #000;
  font-weight: 500;
}
.mine .wrapper .content .finance .finance-item .icon-img{
  width: 80px;
  height: 60px;
}
.mine .wrapper .content .menu{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 0 1.5px 1px 0 #e4e4e7;
}
.mine .wrapper .content .menu .menu-item{
  display: flex;
  align-items: center;
 flex-direction: column;
  width: 33.3%;
  height: 180px;
}
.mine .wrapper .content .menu .menu-item .menu-item-label{
  font-size: 24px;
  color: #432788;
  font-weight: 500;
}
.mine .wrapper .content .menu .menu-item .menu-item-icon{
  margin: 25px;
  width: 60px;
  height: 60px;
  -o-object-fit: contain;
  object-fit: contain;
}
.mine .wrapper .content .wallet{
  margin-top: 80px;
  padding: 0 30px;
  background-color: #a06098;
  border-radius: 15px;
  box-shadow: 0 1.5px 1px 0 #e4e4e7;
}
.mine .wrapper .content .wallet .part-1{
  display: flex;
  align-items: center;
  height: 100px;
}
.mine .wrapper .content .wallet .font-primary-color{
  color: #fff;
  font-size: 32px;
}
.font-gray {
  color: #fff;
  font-size: 28px;
}
.mine .wrapper .content .wallet .part-2{
  display: flex;
  align-items: center;
  height: 10px;
}
.mine .wrapper .content .wallet .part-3{
  display: flex;
  align-items: center;
  height: 80px;
}
.mine .wrapper .content .wallet .part-2 .balance{
  flex: 1;
  font-size: 60px;
  color: #fff;
  font-weight: 700;
}
/* .mine .wrapper .content .wallet .van-hairline--bottom::after {
  border-bottom-width: 3px;
} */
.mine .wrapper .content .wallet .part-2 .refresh-btn{
  margin-left: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  font-size: 30px;
  border-radius: 50%;
  color: #ffffff;
  background-color: #e6c3a1;
}
.btn{
 margin: 40px 0;
}
</style>